import { DefaultTheme } from "styled-components/macro";
import { Scenario } from "./components/curb/ManagerAnalyzer/Manager/SelectScenarios/helpers";
import { StateTypes } from "./components/DesignSystem/Select/styles";

export const defaultLanguage = {
    label: "English",
    value: "en"
};
export const sidebarBetweenMargin = 0;

export const isLocalEnvironment = process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === "local";

export const isProductionEnvironment =
    process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "staging" &&
    process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "local";

export const isLocalSetupValid = (): boolean =>
    isLocalEnvironment && !!process.env.REACT_APP_BASE_URL && !!process.env.REACT_APP_AUTH_TOKEN;

export const shouldLogDataInSentryMixpanel = (): boolean =>
    process.env.REACT_APP_ENVIRONMENT
        ? new Set(["production", "staging"]).has(process.env.REACT_APP_ENVIRONMENT.toLowerCase())
        : false;

export const noActiveLinkColour = "#9B9B9B";
export const lightDisabledColor = "#d3d3d3";
export const themeColor = "#4692A9";
export const DisabledColor = "#dedede";

export const VIEWER_ROUTE = "/viewer/";
export const MANAGER_ROUTE = "/manager/";
export const ANALYZER_ROUTE = "/analyzer/";
export const RULESAPI_ROUTE = "/rulesapi/";
export const LOGINPAGE_ROUTE = "/loginpage/";
export const MANAGER_LIST_VIEW_ROUTE = "/manager/listview/";
export const MANAGER_MAP_VIEW_ROUTE = "/manager/mapview/";
export const ANALYZER_MAP_VIEW_ROUTE = "/analyzer/mapview/";
export const ANALYZER_LIST_VIEW_ROUTE = "/analyzer/listview/";
export const ANALZER_DASHBOARD_VIEW_ROUTE = "/analyzer/dashboardview/";
export const ANALYZER_SUPPLY_DASHBOARD_VIEW_ROUTE = "/analyzer/dashboardview/supply/insights/";
export const ANALYZER_SUPPLY_COMPARISON_DASHBOARD_VIEW_ROUTE =
    "/analyzer/dashboardview/supply/comparison/";
export const ANALYZER_DEMAND_COMPARISON_DASHBOARD_VIEW_ROUTE =
    "/analyzer/dashboardview/demand/comparison/";
export const ANALYZER_DEMAND_HEATMAP_DASHBOARD_VIEW_ROUTE =
    "/analyzer/dashboardview/demand/heatmap/";
export const ANALYZER_DEMAND_TOTAL_EVENTS_HEATMAP_DASHBOARD_VIEW_ROUTE =
    "/analyzer/dashboardview/demand/total-events-heatmap/";
export const ANALYZER_DEMAND_DASHBOARD_VIEW_ROUTE = "/analyzer/dashboardview/demand/insights/";
export const ANALYZER_MAP_VIEW_ROUTE_CREATE = `${ANALYZER_MAP_VIEW_ROUTE}create/`;
export const ANALYZER_MAP_VIEW_ROUTE_EDIT = `${ANALYZER_MAP_VIEW_ROUTE}edit/`;
export const PUBLIC_VIEWER_ROUTE = "/public-default/";
export const REFRESH_TOKEN_API = "/api/token/refresh/";
export const IDENTITY_EXHCANGE_API = "api/identity-exchange/";
export const ACCESS_TOKEN_API = "/api/token/";
export const ACCESS_TOKEN = "accessToken";
export const FORGOT_PASSWORD = "/forgot-password/";
export const RESET_PASSWORD = "/reset-password";
export const RESET_PASSWORD_REQUEST = "/api/request-password-reset/";
export const UPDATE_PASSWORD = "/api/update-password/";
export const HOME_PAGE_ROUTE = VIEWER_ROUTE;

export const HigherMapZIndex = 10;
export const NA = "N/A";

export const timeFormat = "HH:mm";
export const dateFormat = "yyyy-MM-dd";
export const dateTimeFormat = "D-MMM-YYYY HH:mm:ss";
export const payloadTimeFormat = "HH:mm:ss";
export const payloadShortTimeFormat = "HH:mm";
export const payloadDateFormat = "yyyy-MM-dd";
export const dateFormatWithDots = "yyyy.MM.dd";
export const dateTimeWithoutSeconds = "yyyy-MM-dd,HH:mm";
export const DaysWeekWrapperConstant = 100;

export const getRegulationLinksType = {
    getAllCurbLinksWithSameRegulationID: "getAllCurbLinksWithSameRegulationID"
};

export const queryParams = {
    curbLinkId: "curbLinkId",
    customLinkId: "customLinkId",
    isRedirectedFromBatchListView: "isRedirectedFromBatchListView",
    isRedirectedFromListView: "isRedirectedFromListView",
    isRedirectedFromParkingBatchListView: "isRedirectedFromParkingBatchListView",
    proposedRegulationId: "proposedRegulationId",
    regulationId: "regulationId"
};

export const ADMIN_GROUP = "admins";
export const GUEST_GROUP = "guests";
export const CITIES_GROUP = "Cities";
export const VIEW_GROUP = "view";
export const EDIT_GROUP = "edit";
export const PUBLISH_GROUP = "publish";

export const zoneCreatedToast = "zoneCreatedToast";
export const createPolygonToast = "createPolygonToast";
export const createRadiusToast = "createRadiusToast";
export const confirmSelectionToast = "confirmSelectionToast";
export const selectZoneToast = "selectZoneToast";
export const editParkingRatesToast = "editParkingRatesToast";

export const dynamicModules = {
    analyzer: ANALYZER_ROUTE,
    curbrules: RULESAPI_ROUTE,
    manager: MANAGER_ROUTE,
    pfcv: PUBLIC_VIEWER_ROUTE,
    viewer: VIEWER_ROUTE
};

export const dynamicModuleNames = {
    analyzerDashboardView: "analyzerDashboardView",
    analyzerListView: "analyzerListView",
    analyzerMap: "analyzerMap",
    curbrules: "curbrules",
    managerListView: "managerListView",
    managerMap: "managerMap",
    pfcv: "pfcv",
    viewer: "viewer"
};

export const rightPanelWidth = 376;
export const expandedRightPanelWidth = 576;

export const isSpecificScenarioDefault = (
    selectedScenario: Scenario | null,
    scenarioType: "Existing" | "General"
): boolean => !!(selectedScenario?.name === scenarioType && selectedScenario?.default);
export const getBackendBaseUrl = (): string => {
    if (process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "local") {
        return `https://${window.location.hostname.split(".")[0]}.api.${window.location.hostname
            .split(".")
            .slice(1)
            .join(".")}`;
    }

    return `${process.env.REACT_APP_BASE_URL}`;
};

export const getGAToken = (): string | undefined => {
    const gaToken =
        process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === "staging"
            ? process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN_STAG
            : process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN_PROD;

    return (
        process.env[
            `REACT_APP_${window.location.hostname
                .split(".")[0]
                .toUpperCase()}_GOOGLE_ANALYTICS_TOKEN_${
                process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === "staging" ? "STAG" : "PROD"
            }`
        ] ?? gaToken
    );
};

export const getBackgroundColor = (
    state: StateTypes,
    theme: DefaultTheme,
    customColors?: { selected?: string; focused?: string }
): string => {
    if (state.isSelected && customColors?.selected) {
        return customColors.selected;
    }
    if (state.isFocused && customColors?.focused) {
        return customColors.focused;
    }

    // Default colors from theme
    if (state.isSelected) {
        return theme.colors.primary.light.backgroundColor;
    }
    if (state.isFocused) {
        return theme.colors.primary.light.backgroundColor;
    }

    return "#FFFFFF";
};

export const demoVideoURL = "https://www.youtube.com/embed/4ShvSe1voe8?si=liCj3BP4iFo9MduQ";
